import { render, staticRenderFns } from "./ReferralPathwaysBarChart.vue?vue&type=template&id=1bde6868&scoped=true"
import script from "./ReferralPathwaysBarChart.vue?vue&type=script&lang=js"
export * from "./ReferralPathwaysBarChart.vue?vue&type=script&lang=js"
import style0 from "./ReferralPathwaysBarChart.vue?vue&type=style&index=0&id=1bde6868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde6868",
  null
  
)

export default component.exports